import { DisabledTag } from '@nile/mangifera/src/Pebbles/TicketContainer';
import React, { useCallback, useState, useEffect } from 'react';
import styled from 'styled-components';
import InlineTextField from '@nile/components/src/Components/InlineEdit/Components/InlineTextField';
import { SVGIcon } from '@superops/super-icons';
import { DisplayText } from '@superops/ui-design-system';

const Wrap = styled.div`
  opacity: ${(props) => props.hiddenField && '0.5'};

  .edit-actions {
    visibility: hidden;
    cursor: pointer;
  }
  .subject-name {
    height: 100%;
    line-height: 3.3rem;
    max-height: 110px;
    overflow: auto;
    padding-right: 5px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 350px;
  }

  .subject,
  .Superops-TextField.Superops-TextField--fontMedium {
    font-size: 14px !important;
    font-weight: 700 !important;
  }

  .Superops-Connected {
    padding: 0;
  }

  .Superops-TextField__Input {
    width: 400px;
  }

  .eye-hidden {
    position: absolute;
    right: 0;
  }
`;

function TextInlineEditCell(props) {
  const { cell, params } = props;
  const allProps = params || cell.column;
  const { actions } = allProps;
  let currentCell = cell.row.original;
  const [editMode, setEditMode] = useState(currentCell?.isRenameMode || false);
  const hasEditPermission = cell?.column?.columnDef?.hasEditPermission ?? true;

  // Allow editing if user has edit permission OR if it's a new folder
  const canEdit = hasEditPermission || currentCell?.isNewFolderMode;

  useEffect(() => {
    let focusTimer;
    if (currentCell?.isRenameMode || currentCell?.isNewFolderMode) {
      focusTimer = setTimeout(() => {
        setEditMode(true);
      }, 500);
    }
    return () => clearTimeout(focusTimer);
  }, [currentCell?.isRenameMode, currentCell?.isNewFolderMode]);

  function handleRename(text: string, cb) {
    let oldName = currentCell.name;
    let parent = currentCell.parent;
    if (currentCell.isNewFolderMode) {
      if (!actions.checkIfAlreadyExists(text)) {
        actions.addNewFolder(text);
        cb('success');
        setEditMode(false);
      } else {
        setEditMode(true);
      }
    } else {
      if (text && text !== oldName) {
        if (!actions.checkIfAlreadyExists(text)) {
          actions.save(oldName, text, parent, currentCell?.isDir);
          cb('success');
          setEditMode(false);
        }
      } else {
        actions?.cancelRenameFolder();
        cb('success');
        setEditMode(false);
      }
    }
    // tableActions['setRenameMode'](currentCell, false)
  }

  function onCancel() {
    if (currentCell?.isNewFolderMode) {
      actions?.cancelAddFolder();
    }
    if (currentCell?.isRenameMode) {
      actions?.cancelRenameFolder();
    }
  }

  let icon = currentCell?.isDir ? 'FolderClosed' : 'NotesBlue';

  const getDisplayValue = useCallback(
    (cell) => {
      let val = '';
      if (typeof cell.value === 'object' && cell.value?.name) {
        val = cell.value?.name;
      } else if (cell.value === 0) {
        //Handling this case to override falsy case as metric happens to be zero at times
        val = String(cell.value);
      } else if (cell.value || cell.name) {
        val = cell.value || cell.name;
      }
      if (val) return val;
      else return <DisabledTag>NA</DisabledTag>;
    },
    [cell.value]
  );

  function handleDoubleClick() {
    currentCell?.isDir &&
      !editMode &&
      actions?.onDoubleClick.bind(this, props.cell.row.original)();
  }

  // if (currentCell?.isRenameMode) {
  //   setEditMode(true)
  // }

  return (
    <Wrap
      title={`${getDisplayValue(cell)} ${
        currentCell?.isHidden === 'true' ? '- hidden file' : ''
      }`}
      onDoubleClick={handleDoubleClick}
      hiddenField={currentCell?.isHidden === 'true'}
      className="cell full-width flex actr position-relative pr8 mw-100"
    >
      <span className="mt4 mr12">
        <SVGIcon name={icon} />
      </span>
      <div className="overflow-ellipses">
        {canEdit ? (
          <InlineTextField
            defaultValue={getDisplayValue(cell)}
            saveValue={(value, cb) => {
              handleRename(value, cb);
            }}
            saveOnEnter={true}
            editMode={editMode}
            onCancel={onCancel}
            setEditState={(state) => {
              setEditMode(state);
            }}
          />
        ) : (
          <DisplayText element="span" size={'default'} weight={'Medium'}>
            {getDisplayValue(cell)}
          </DisplayText>
        )}
      </div>
      {currentCell?.isHidden === 'true' && (
        <span className="eye-hidden">
          <SVGIcon name="EyeHidden" />
        </span>
      )}
    </Wrap>
  );
}

export default TextInlineEditCell;
